import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import TabBar from "rc-tabs/lib/TabBar";
import { Link } from "react-router-dom";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import BodegasList from "./Bodegas";
import { AlmacenesPadreTab } from "./AlmacenesPadreTab";

class BodegasTabs extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tabFromUrl = params.get("tab");

        // significa que fue carga nueva, por lo tanto no se conserva el estado anterior de filtros y página
        if (!tabFromUrl) {
            tabFromUrl = "BODEGAS";

            params.set("tab", tabFromUrl);

            this.props.history.replace({
                search: params.toString(),
            });
        }

        this.state = {
            tab: tabFromUrl,
        };
    }

    handleChangeTab = (tab) => {
        this.setState({ tab });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab", tab);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    render() {
        const { user } = this.props;
        let permisos = {};

        if (user.rol_usuario) {
            permisos = user.rol_usuario;
        }

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="configuraciones_activo"
                    titulo="ALMACÉN / PILA"
                    subtitulo="Materia prima"
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent />}
                    >
                        <TabPane tab="BODEGAS" key="BODEGAS">
                            <BodegasList />
                        </TabPane>

                        <TabPane tab="ALMACENES PADRE" key="ALMACENES_PADRE">
                            <AlmacenesPadreTab />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(BodegasTabs);
